import React from 'react';
import styled from 'styled-components';

import Spacer from 'components/ui/Spacer';
import Select from 'components/ui/SelectField';
import Form from 'components/ui/Form';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';

import { ConfigProvider, Empty as AntEmpty } from 'antd';
import { getTranslatedString } from 'helpers/i18n';

const FullWidthSelect = styled(Select)`
  width: 100%;
`;

const StyledTitleText = styled.div`
  font-weight: 500;
  font-size: 18px;
`;

const StyledContainer = styled.div`
  padding-top: 40px;
`;

const Empty = () => (
  <AntEmpty description={getTranslatedString('noData')} image={AntEmpty.PRESENTED_IMAGE_SIMPLE} />
);

const TicketStatus = ({ status, values, setFieldValue, touched, errors, disabled }) => {
  const handleStatusChange = (value) => {
    setFieldValue('status', value);
  };

  const vendorStatuses = [
    {
      label: getTranslatedString('maintenanceVendors.ticketStatus.fixed'),
      value: 'Fixed',
    },
    {
      label: getTranslatedString('maintenanceVendors.ticketStatus.notFixed.ongoing'),
      value: 'vendor_ongoing',
    },
    {
      label: getTranslatedString('maintenanceVendors.ticketStatus.notFixed.other'),
      value: 'vendor_other',
    },
    {
      label: getTranslatedString('maintenanceVendors.ticketStatus.notFixed.cancelled'),
      value: 'vendor_cancelled',
    },
  ];

  return (
    <StyledContainer>
      <ConfigProvider renderEmpty={Empty} image={Empty.PRESENTED_IMAGE_SIMPLE}>
        <Spacer mb={1}>
          <Row gutter={16}>
            <Col span={24}>
              <StyledTitleText>
                {getTranslatedString('maintenanceVendors.changeStatus.title')}
              </StyledTitleText>
              <Form.Item
                label={`${getTranslatedString('maintenanceVendors.changeStatus.body')}*`}
                validateStatus={touched.status && errors.status ? 'error' : null}
                help={touched.status && errors.status}
                labelAlign="left"
              >
                <FullWidthSelect
                  name="status"
                  showSearch
                  placeholder={getTranslatedString('landlordPortal.maintenance.tickets.select')}
                  size="large"
                  value={values.status}
                  onChange={handleStatusChange}
                  disabled={disabled}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {vendorStatuses.map((status) => (
                    <Select.Option value={status.value} key={status.value}>
                      {status.label}
                    </Select.Option>
                  ))}
                </FullWidthSelect>
              </Form.Item>
            </Col>
          </Row>
        </Spacer>
      </ConfigProvider>
    </StyledContainer>
  );
};

export default TicketStatus;
